var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 120 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: "4px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.18 90.8801V102.95L2.5 60.4201V48.3401L76.18 90.8801Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7098 72.8001V84.8801L22.4998 47.8101L13.7098 42.7301L13.0298 42.3401V30.2601L86.7098 72.8001Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1797 80.8801V92.9501L76.1797 102.95V90.8801L96.1797 80.8801Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2298 54.7202V66.8002L33.0298 29.7302L24.2398 24.6602L23.5498 24.2602V12.1802L97.2298 54.7202Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.23 44.7202V56.8002L106.02 62.4002L97.23 66.8002V54.7202L106.02 50.3302L117.23 44.7202Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.23 44.7202L106.02 50.3302L97.2298 54.7202L23.5498 12.1802L43.5498 2.18018L117.23 44.7202Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.71 62.8002V74.8802L95.5 80.4902L86.71 84.8802V72.8002L95.5 68.4102L106.71 62.8002Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.71 62.8002L95.4998 68.4102L86.7098 72.8002L13.0298 30.2602L24.2398 24.6602L33.0298 29.7302L97.2298 66.8002L106.02 62.4002L106.71 62.8002Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.18 80.8802L76.18 90.8802L2.5 48.3402L13.71 42.7302L22.5 47.8102L86.71 84.8802L95.5 80.4902L96.18 80.8802Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.4fab1054c92b8351915e6b22c423279f.svg";
export { ForwardRef as ReactComponent };